import { render, staticRenderFns } from "./CustomerStatementView.vue?vue&type=template&id=7d630d45"
import script from "./CustomerStatementView.vue?vue&type=script&lang=js"
export * from "./CustomerStatementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports